// src/constants/translations.js
export const HEBREW_TRANSLATIONS = {
  // Navigation
  dashboard: 'לוח בקרה',
  schedule: 'יומן תורים',
  customers: 'לקוחות',
  services: 'שירותים',
  crewMembers: 'חברי צוות',
  automations: 'אוטומציות',
  campaigns: 'קמפיינים',
  sidebarTitle: 'מערכת CRM',
  sidebarSubtitle: 'ניהול מכון יופי',

  // Common Actions
  add: 'הוסף',
  edit: 'ערוך',
  delete: 'מחק',
  save: 'שמור',
  cancel: 'ביטול',
  close: 'סגור',
  submit: 'שלח',
  search: 'חיפוש',
  filter: 'סינון',
  export: 'ייצוא',
  import: 'ייבוא',

  // Status
  active: 'פעיל',
  inactive: 'לא פעיל',
  pending: 'ממתין',
  confirmed: 'מאושר',
  completed: 'הושלם',
  cancelled: 'בוטל',

  // Appointment statuses
  scheduled: 'מתוזמן',
  inProgress: 'בטיפול',
  noShow: 'לקוח לא הגיע',
  noShowJustified: 'לקוח לא הגיע - מוצדק',

  // Forms
  fullName: 'שם מלא',
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
  phone: 'טלפון',
  email: 'אימייל',
  address: 'כתובת',
  birthDate: 'תאריך לידה',
  notes: 'הערות',
  required: 'שדה חובה',
  addressPlaceholder: 'רחוב, עיר',
  gender: 'מין',
  female: 'נקבה',
  male: 'זכר',

  // Placeholders
  enterFullName: 'הזן שם מלא',
  enterPhone: 'הזן מספר טלפון',
  enterEmail: 'הזן כתובת אימייל',
  selectDate: 'בחר תאריך',
  selectTime: 'בחר שעה',
  selectService: 'בחר שירות',
  selectCustomer: 'בחר לקוח',

  // Customer Management
  newCustomer: 'צור לקוח חדש',
  newCustomerDesc: 'יצירת פרופיל לקוח חדש',
  editCustomer: 'עריכת לקוח',
  customerDetails: 'פרטי לקוח',
  customerHistory: 'היסטוריית לקוח',
  lastVisit: 'ביקור אחרון',
  totalVisits: 'סה"כ ביקורים',
  customerManagement: 'ניהול לקוחות',
  manageYourClientDatabase: 'נהל את מאגר הלקוחות שלך',
  addCustomer: 'הוסף לקוח',
  loadingCustomers: 'טוען לקוחות...',
  searchCustomersByNamePhoneEmail: 'חפש לקוחות לפי שם, טלפון או אימייל...',
  viewDetails: 'צפה בפרטים',
  preferredServices: 'שירותים מועדפים',
  hasAllergies: 'יש אלרגיות',
  noCustomersFound: 'לא נמצאו לקוחות',
  noCustomersYet: 'אין לקוחות עדיין',
  tryAdjustingSearchTerms: 'נסה לשנות את מונחי החיפוש',
  getStartedByAddingFirstCustomer: 'התחל על ידי הוספת הלקוח הראשון שלך',
  more: 'עוד',
  // Customer Detail Page  
  viewCustomerProfileAndHistory: 'צפה בפרופיל לקוח והיסטוריית תורים',
  loadingCustomerDetails: 'טוען פרטי לקוח...',
  customerNotFound: 'לקוח לא נמצא',
  requestedCustomerCouldNotBeFound: 'הלקוח המבוקש לא נמצא.',
  valuedClient: 'לקוח יקר',
  allergiesAndSensitivities: 'אלרגיות ורגישויות',
  clientNotes: 'הערות לקוח',
  bookAppointment: 'קבע תור',
  // Customer Form Fields
  skinType: 'סוג עור',
  allergies: 'אלרגיות',
  preferredContact: 'דרך יצירת קשר מועדפת',
  // Skin Type Options
  normal: 'רגיל',
  dry: 'יבש',
  oily: 'שמן',
  combination: 'מעורב',
  sensitive: 'רגיש',
  mature: 'בוגר',
  skinTypeMapping: {
    normal: 'רגיל',
    dry: 'יבש',
    oily: 'שמן',
    combination: 'מעורב',
    sensitive: 'רגיש',
    mature: 'בוגר'
  },
  // Customer card statistics translations
  viewStatistics: 'צפה בסטטיסטיקות',
  hideStatistics: 'הסתר סטטיסטיקות',
  loadingStats: 'טוען סטטיסטיקות...',
  statistics: 'סטטיסטיקות',
  customerStatistics: 'סטטיסטיקות לקוח',
  // Enhanced customer status labels  
  activeCustomer: 'לקוח פעיל',
  inactiveCustomer: 'לקוח לא פעיל',
  newCustomer: 'לקוח חדש',
  returningCustomer: 'לקוח חוזר',
  // Stats display labels
  totalSpent: 'סה"כ הוצא',
  totalAppointments: 'סה"כ תורים',
  completedAppointments: 'תורים שהושלמו',
  lastVisit: 'ביקור אחרון',
  averageSpent: 'ממוצע הוצאה',
  completionRate: 'שיעור השלמה',
  // Additional customer details
  phoneNumber: 'מספר טלפון',
  emailAddress: 'כתובת אימייל',
  editCustomer: 'ערוך לקוח',
  // Contact Preferences
  whatsapp: 'וואטסאפ',
  // Additional Customer-related terms
  customerSince: 'לקוח מאז',
  totalSpent: 'סה"כ הוצאות',
  averageVisitValue: 'ערך ממוצע לביקור',
  daysSinceLastVisit: 'ימים מאז הביקור האחרון',
  appointmentHistory: 'היסטוריית תורים',
  backToCustomers: 'חזור ללקוחות',
  // Customer Modal specific translations
  addNewCustomer: 'הוסף לקוח חדש',
  editCustomer: 'ערוך לקוח',
  customerUpdatedSuccessfully: 'לקוח עודכן בהצלחה!',
  customerAddedSuccessfully: 'לקוח נוסף בהצלחה!',
  customerInformationHasBeenUpdated: 'פרטי הלקוח עודכנו.',
  newCustomerHasBeenAddedToDatabase: 'הלקוח החדש נוסף למאגר הנתונים.',
  updatingCustomer: 'מעדכן לקוח...',
  updateCustomer: 'עדכן לקוח',
  addingCustomer: 'מוסיף לקוח...',
  // Form labels and placeholders
  fullName: 'שם מלא',
  phoneNumber: 'מספר טלפון',
  emailAddress: 'כתובת אימייל',
  birthDate: 'תאריך לידה',
  enterCustomerFullName: 'הזן את השם המלא של הלקוח',
  customerEmailPlaceholder: 'customer@email.com',
  phonePlaceholder: '050-1234567',
  // Form hints and help text
  optionalForAppointmentConfirmations: 'אופציונלי - לאישורי תורים',
  helpsWithAgeAppropriateServiceRecommendations: 'עוזר עם המלצות שירות מתאימות לגיל',
  selectSkinTypeOptional: 'בחר סוג עור (אופציונלי)',
  helpsWithServiceRecommendations: 'עוזר עם המלצות שירותים',
  listAnyKnownAllergiesOrSensitivities: 'רשום כל אלרגיה או רגישות ידועה...',
  importantForServiceSafety: 'חשוב לבטיחות השירות',
  additionalNotesAboutCustomer: 'הערות נוספות על הלקוח...',
  preferencesSpecialInstructions: 'העדפות, הוראות מיוחדות, וכד\'',

  // Appointment Management
  newAppointment: 'קבע תור חדש',
  newAppointmentDescription: 'קביעת תור חדש',
  editAppointment: 'עריכת תור',
  appointmentDetails: 'פרטי תור',
  date: 'תאריך',
  time: 'שעה',
  duration: 'משך זמן',
  service: 'שירות',
  customer: 'לקוח',
  therapist: 'מטפלת',
  // Responsive Design Labels
  mobileView: 'תצוגה ניידת',
  desktopView: 'תצוגה שולחנית',
  compactView: 'תצוגה קומפקטית',
  bookNewAppointment: 'קבע תור חדש',
  bookingAppointmentFor: 'קביעת תור עבור',
  updated: 'עודכן',
  deleted: 'נמחק',
  created: 'נוצר',
  successfully: 'בהצלחה',
  customerRequired: 'לקוח הוא שדה חובה',
  serviceRequired: 'שירות הוא שדה חובה',
  crewMemberRequired: 'חברת צוות היא שדה חובה',
  dateRequired: 'תאריך הוא שדה חובה',
  timeRequired: 'שעה היא שדה חובה',
  validDurationRequired: 'משך זמן תקין הוא שדה חובה',
  validPriceRequired: 'מחיר תקין הוא שדה חובה',
  selectCustomer: 'בחר לקוח',
  selectService: 'בחר שירות',
  selectCrewMember: 'בחר חברת צוות',
  durationMinutes: 'משך זמן (דקות)',
  priceShekels: 'מחיר (₪)',
  additionalNotesPlaceholder: 'הערות נוספות לתור זה...',
  failedToSaveAppointment: 'שגיאה בשמירת התור',
  failedToDeleteAppointment: 'שגיאה במחיקת התור',
  deleteAppointment: 'מחק תור',
  deleteAppointmentConfirm: 'האם אתה בטוח שברצונך למחוק תור זה? פעולה זו לא ניתנת לביטול.',
  saving: 'שומר...',
  deleting: 'מוחק...',
  updateAppointment: 'עדכן תור',
  bookAppointment: 'קבע תור',

  // Appointment History component translations
  appointmentHistory: 'היסטוריית תורים',
  noAppointmentsYet: 'אין תורים עדיין',
  thisCustomerHasntBookedAnyAppointments: 'הלקוח הזה עדיין לא קבע תורים.',

  // Appointment table headers
  service: 'שירות',
  dateAndTime: 'תאריך ושעה',
  crew: 'צוות',
  status: 'סטטוס',
  price: 'מחיר',
  noCrewAssigned: 'לא שויך צוות',

  // Additional status and display terms
  dash: '-',  // for empty fields
  unknown: 'לא ידוע',

  // AppointmentHistory.js component specific translations
  appointmentHistory: 'היסטוריית תורים',
  noAppointmentsYet: 'אין תורים עדיין',
  thisCustomerHasntBookedAnyAppointments: 'הלקוח הזה עדיין לא קבע תורים.',
  // Desktop table headers
  service: 'שירות',
  dateAndTime: 'תאריך ושעה',
  crew: 'צוות',
  status: 'סטטוס',
  price: 'מחיר',
  // Mobile view and general appointment terms
  noCrewAssigned: 'לא שויך צוות',
  // Appointment status translations
  statusMapping: {
    scheduled: 'מתוזמן',
    confirmed: 'מאושר',
    completed: 'הושלם',
    cancelled: 'בוטל',
    no_show: 'לקוח לא הגיע',
    no_show_justified: 'לקוח לא הגיע - מוצדק',
    pending_approval: 'ממתין לאישור'
  },
  // Currency and time formatting
  currencySymbol: '₪',  // Israeli Shekel symbol
  at: 'בשעה',  // For "Date at Time" format

  // Service Management
  serviceVisibilitySettings: 'הגדרות נראות שירות',
  visibleToCustomers: 'גלוי ללקוחות',
  visibleToCustomersDescription: 'האם השירות יופיע ללקוחות בתהליך הזמנת התור',
  showPriceToCustomers: 'הצג מחיר ללקוחות',
  showPriceToCustomersDescription: 'האם המחיר יוצג ללקוחות (רלוונטי רק אם השירות גלוי ללקוחות)',
  internalService: 'שירות פנימי',
  internalServiceWarning: 'השירות הזה יהיה זמין רק לצוות ולא יופיע ללקוחות בתהליך הזמנת התור.',
  newService: 'צור שירות חדש',
  manageServicesDesc: 'עדכון תפריט שירותים',
  editService: 'עריכת שירות',
  serviceName: 'שם השירות',
  serviceDescription: 'תיאור השירות',
  servicePrice: 'מחיר',
  serviceDuration: 'משך זמן',
  serviceCategory: 'קטגוריה',
  // Services.js page translations
  serviceManagement: 'ניהול שירותים',
  manageYourBeautyServiceOfferings: 'נהל את מבחר השירותים שלך',
  addService: 'הוסף שירות',
  loadingServices: 'טוען שירותים...',
  // Service Modal translations
  addNewService: 'הוסף שירות חדש',
  editService: 'ערוך שירות',
  serviceUpdatedSuccessfully: 'השירות עודכן בהצלחה!',
  serviceAddedSuccessfully: 'השירות נוסף בהצלחה!',
  serviceInformationHasBeenUpdated: 'פרטי השירות עודכנו.',
  newServiceHasBeenAddedToMenu: 'השירות החדש נוסף לתפריט שלך.',
  updatingService: 'מעדכן שירות...',
  updateService: 'עדכן שירות',
  addingService: 'מוסיף שירות...',
  // Service form fields
  serviceName: 'שם השירות',
  enterServiceName: 'הזן שם השירות',
  category: 'קטגוריה',
  selectACategory: 'בחר קטגוריה',
  chooseTheServiceCategory: 'בחר את קטגוריית השירות',
  durationMinutes: 'משך זמן (דקות)',
  priceILS: 'מחיר (₪)',
  serviceDescription: 'תיאור השירות',
  describeWhatThisServiceIncludes: 'תאר מה כולל השירות הזה...',
  helpCustomersUnderstand: 'עזור ללקוחות להבין מה הם מקבלים',
  serviceActive: 'השירות פעיל',
  enableToShowInBookings: 'הפעל כדי להציג בהזמנות',
  // Service categories
  allServices: 'כל השירותים',
  permanentMakeup: 'איפור קבוע',
  hairRemoval: 'הסרת שיער',
  aesthetics: 'אסתטיקה',
  consultation: 'ייעוץ',
  privateLesson: 'שיעור פרטי',
  // Service grid and display
  allYourAvailableServices: 'כל השירותים הזמינים שלך',
  servicesInTheCategory: 'שירותים בקטגוריית',
  minutes: 'דקות',
  hour: 'שעה',
  hours: 'שעות',
  deactivate: 'הפוך ללא פעיל',
  activate: 'הפעל',
  clickToEditServiceDetails: 'לחץ לעריכת פרטי השירות',
  // Empty states
  noServicesYet: 'אין שירותים עדיין',
  noServicesInCategory: 'אין שירותים ב',
  getStartedByAddingFirstService: 'התחל על ידי הוספת השירות הראשון שלך',
  addServicesToCategory: 'הוסף שירותים לקטגוריה כדי לראות אותם כאן',
  addYourFirstService: 'הוסף את השירות הראשון שלך',
  addServiceToCategory: 'הוסף שירות ל',
  // Service statistics
  totalServices: 'סה"כ שירותים',
  active: 'פעיל',
  avgPrice: 'מחיר ממוצע',
  avgDuration: 'משך זמן ממוצע',

  // Categories
  facial: 'טיפולי פנים',
  massage: 'עיסוי',
  hairRemoval: 'הסרת שיער',
  bodyTreatments: 'טיפולי גוף',
  manicure: 'מניקור',
  pedicure: 'פדיקור',
  makeup: 'איפור',

  // Time slots
  morning: 'בוקר',
  afternoon: 'אחר הצהריים',
  evening: 'ערב',

  // Days of week
  sunday: 'ראשון',
  monday: 'שני',
  tuesday: 'שלישי',
  wednesday: 'רביעי',
  thursday: 'חמישי',
  friday: 'שישי',
  saturday: 'שבת',

  // Months
  january: 'ינואר',
  february: 'פברואר',
  march: 'מרץ',
  april: 'אפריל',
  may: 'מאי',
  june: 'יוני',
  july: 'יולי',
  august: 'אוגוסט',
  september: 'ספטמבר',
  october: 'אוקטובר',
  november: 'נובמבר',
  december: 'דצמבר',

  // Messages
  success: 'פעולה בוצעה בהצלחה',
  error: 'אירעה שגיאה',
  confirmDelete: 'האם אתה בטוח שברצונך למחוק?',
  noData: 'אין נתונים להצגה',
  loading: 'טוען...',

  // Validation messages
  fieldRequired: 'שדה זה הוא חובה',
  invalidEmail: 'כתובת אימייל לא תקינה',
  invalidPhone: 'מספר טלפון לא תקין',
  phoneRequired: 'נדרש מספר טלפון',
  emailRequired: 'נדרשת כתובת אימייל',

  // Business info
  businessName: 'מכון יופי',
  businessSubtitle: 'יופי ובריאות',

  // Dashboard
  todayAppointments: 'תורים להיום',
  upcomingAppointments: 'תורים עתידיים',
  totalCustomers: 'סה"כ לקוחות',
  monthlyRevenue: 'הכנסות חודשיות',
  welcomeTitle: 'עמוד בקרה ראשי',
  welcomeSubtitle: 'ברוכים הבאים למערכת ניהול המכון שלך',

  // Staff management
  staff: 'צוות',
  newStaffMember: 'איש צוות חדש',
  staffMember: 'איש צוות',
  role: 'תפקיד',
  specialization: 'התמחות',
  workingHours: 'שעות עבודה',

  // Dashboard specific
  manageServices: 'ניהול שירותים',
  viewAll: 'צפה בהכל',
  quickActions: 'פעולות מהירות',
  noAppointments: 'אין תורים',
  noSchedule: 'אין תורים מתוזמנים להיום',
  scheduleAppointment: 'קבע תור',

  // Appointment related
  yourAppointments: 'התורים שלך',
  appointmentsForToday: 'התורים שלך להיום',
  sendReminder: 'שלח תזכורת',
  sending: 'שולח...',
  sent: 'נשלח!',
  clickToView: 'לחץ לצפייה',

  // Service related  
  unknownCustomer: 'לקוח לא ידוע',
  unknownService: 'שירות לא ידוע',
  noPhone: 'אין טלפון',

  // Action descriptions (for quick actions)
  scheduleNewBooking: 'קבע הזמנה חדשה',
  createCustomerProfile: 'צור פרופיל לקוח',
  updateServiceMenu: 'עדכן תפריט שירותים',

  // General UI
  fullSchedule: 'לוח זמנים מלא',
  viewFullSchedule: 'צפה בלוח זמנים המלא',
  price: 'מחיר',
  minutes: 'דקות',

  // Time and date
  today: 'היום',
  upcoming: 'קרוב',

  // Status messages
  noUpcomingAppointments: 'אין תורים קרובים',

  // Hebrew translations for Schedule.js - Add these to HEBREW_TRANSLATIONS object

  // Schedule Management
  scheduleManagement: 'ניהול יומן תורים',
  manageAppointmentBookings: 'נהל את הזמנות התורים',
  newAppointment: 'תור חדש',
  loadingScheduleData: 'טוען נתוני יומן...',

  // Navigation and Time Controls
  today: 'היום',
  week: 'שבוע',
  month: 'חודש',
  previousWeek: 'שבוע קודם',
  nextWeek: 'שבוע הבא',
  showSaturday: 'הצג שבת',
  time: 'שעה',

  // Crew Member Management
  assignedServices: 'שירותים מוקצים',
  noAssignedServices: 'אין שירותים מוקצים',
  unknownService: 'שירות לא ידוע',
  crewMember: 'חבר צוות',
  allMembers: 'כל חברי הצוות',
  crewMembers: 'חברי צוות',
  viewSchedule: 'צפה ביומן',
  // CrewMembers.js page translations
  crewMemberManagement: 'ניהול צוות',
  manageYourTeamMembersAndSpecialties: 'נהל את חברי הצוות וההתמחויות שלהם',
  addCrewMember: 'הוסף חבר צוות',
  crewMembers: 'חברי צוות',
  // Stats cards
  totalMembers: 'סה"כ חברים',
  totalTeamMembers: 'סה"כ חברי צוות',
  specialties: 'התמחויות',
  // Search and filters
  searchCrewMembers: 'חפש חברי צוות...',
  showInactive: 'הצג לא פעילים',
  // Table headers
  member: 'חבר צוות',
  contact: 'יצירת קשר',
  status: 'סטטוס',
  actions: 'פעולות',
  // Empty states
  noCrewMembersFound: 'לא נמצאו חברי צוות',
  tryAdjustingSearchCriteria: 'נסה לשנות את קריטריוני החיפוש.',
  getStartedByAddingFirstCrewMember: 'התחל על ידי הוספת חבר הצוות הראשון שלך.',
  // Crew member data display
  noEmail: 'אין אימייל',
  noPhone: 'אין טלפון',
  noSpecialties: 'אין התמחויות',
  // Action buttons and confirmations
  editCrewMember: 'ערוך חבר צוות',
  deactivate: 'השבת',
  activate: 'הפעל',
  areYouSureDeactivate: 'האם אתה בטוח שברצונך להשבית את חבר הצוות הזה?',
  // Error messages
  errorLoadingCrewMembers: 'שגיאה בטעינת חברי הצוות',
  errorDeactivatingCrewMember: 'שגיאה בהשבתת חבר הצוות',
  errorActivatingCrewMember: 'שגיאה בהפעלת חבר הצוות',
  // Loading states
  loadingCrewMembers: 'טוען חברי צוות...',
  // CrewMemberModal translations
  addNewCrewMember: 'הוסף חבר צוות חדש',
  editCrewMember: 'ערוך חבר צוות',
  crewMemberUpdated: 'חבר הצוות עודכן!',
  crewMemberAdded: 'חבר הצוות נוסף!',
  crewMemberHasBeenUpdatedSuccessfully: 'חבר הצוות עודכן בהצלחה.',
  newCrewMemberHasBeenAddedToTeam: 'חבר הצוות החדש נוסף לצוות שלך.',
  updating: 'מעדכן...',
  updateCrewMember: 'עדכן חבר צוות',
  adding: 'מוסיף...',
  // Form fields
  name: 'שם',
  nameRequired: 'שם הוא שדה חובה',
  enterFullName: 'הזן שם מלא',
  email: 'אימייל',
  phone: 'טלפון',
  optional: 'אופציונלי',
  quickAdd: 'הוספה מהירה',
  addCustomSpecialty: 'הוסף התמחות מותאמת אישית',
  add: 'הוסף',
  color: 'צבע',
  chooseColor: 'בחר צבע',
  memberIsActive: 'החבר פעיל',
  // Predefined specialties (Hebrew translations)
  hairRemoval: 'הסרת שיער',
  permanentMakeup: 'איפור קבוע',
  medicalAesthetics: 'אסתטיקה רפואית',
  laserTreatments: 'טיפולי לייזר',
  iplTreatments: 'טיפולי IPL',
  microblading: 'מיקרובליידינג',
  botox: 'בוטוקס',
  hyaluronicAcid: 'חומצה היאלורונית',
  skinTreatments: 'טיפולי עור',
  // Color names
  blue: 'כחול',
  green: 'ירוק',
  yellow: 'צהוב',
  red: 'אדום',
  purple: 'סגול',
  cyan: 'ציאן',
  orange: 'כתום',
  lime: 'ליים',
  pink: 'ורוד',
  indigo: 'אינדיגו',
  // Validation messages
  nameAtLeast2Characters: 'השם חייב להכיל לפחות 2 תווים',
  invalidEmailFormat: 'פורמט אימייל לא תקין',
  invalidPhoneFormat: 'פורמט טלפון לא תקין',
  // Work Frequency translations
  worksEveryXWeeks: 'עובד כל X שבועות',
  workFrequency: 'תדירות עבודה',
  referenceDate: 'תאריך ייחוס',
  workFrequencyDescription: 'קבע כל כמה שבועות חבר הצוות עובד',
  selectReferenceDate: 'בחר תאריך ייחוס להתחלת מחזור העבודה',
  referenceDateRequired: 'תאריך ייחוס נדרש כאשר תדירות העבודה גדולה משבוע',
  workFrequencyInvalidRange: 'תדירות העבודה חייבת להיות בין 1 ל-8 שבועות',
  // Work frequency options
  everyWeek: 'כל שבוע',
  every2Weeks: 'כל שבועיים',
  every3Weeks: 'כל 3 שבועות',
  every4Weeks: 'כל 4 שבועות',
  every5Weeks: 'כל 5 שבועות',
  every6Weeks: 'כל 6 שבועות',
  every7Weeks: 'כל 7 שבועות',
  every8Weeks: 'כל 8 שבועות',
  // Work frequency conflict translations
  workFrequencyConflict: 'התנגשות תדירות עבודה',
  worksEvery: 'עובד כל',
  weeksOnly: 'שבועות בלבד',
  startingFrom: 'החל מ',
  selectedDateNotInWorkingWeek: 'התאריך שנבחר אינו בשבוע עבודה עבור',
  // CrewMemberModal.js translations
  addNewCrewMember: 'הוסף חבר צוות חדש',
  editCrewMember: 'ערוך חבר צוות',
  crewMemberUpdated: 'חבר הצוות עודכן!',
  crewMemberAdded: 'חבר הצוות נוסף!',
  crewMemberHasBeenUpdatedSuccessfully: 'חבר הצוות עודכן בהצלחה.',
  newCrewMemberHasBeenAddedToTeam: 'חבר הצוות החדש נוסף לצוות שלך.',
  updating: 'מעדכן...',
  updateCrewMember: 'עדכן חבר צוות',
  adding: 'מוסיף...',
  // Form fields
  name: 'שם',
  nameRequired: 'שם הוא שדה חובה',
  enterFullName: 'הזן שם מלא',
  email: 'אימייל',
  enterEmailAddress: 'הזן כתובת אימייל',
  phone: 'טלפון',
  enterPhoneNumber: 'הזן מספר טלפון',
  optional: 'אופציונלי',
  chooseColor: 'בחר צבע',
  memberIsActive: 'החבר פעיל',
  // Specialties section
  specialties: 'התמחויות',
  quickAdd: 'הוספה מהירה',
  addCustomSpecialty: 'הוסף התמחות מותאמת אישית',
  add: 'הוסף',
  // Predefined specialties (Hebrew translations)
  hairRemoval: 'הסרת שיער',
  permanentMakeup: 'איפור קבוע',
  medicalAesthetics: 'אסתטיקה רפואית',
  laserTreatments: 'טיפולי לייזר',
  iplTreatments: 'טיפולי IPL',
  microblading: 'מיקרובליידינג',
  botox: 'בוטוקס',
  hyaluronicAcid: 'חומצה היאלורונית',
  skinTreatments: 'טיפולי עור',
  // Color names
  blue: 'כחול',
  green: 'ירוק',
  yellow: 'צהוב',
  red: 'אדום',
  purple: 'סגול',
  cyan: 'ציאן',
  orange: 'כתום',
  lime: 'ליים',
  pink: 'ורוד',
  indigo: 'אינדיגו',
  // Validation messages
  nameAtLeast2Characters: 'השם חייב להכיל לפחות 2 תווים',
  invalidEmailFormat: 'פורמט אימייל לא תקין',
  invalidPhoneFormat: 'פורמט טלפון לא תקין',
  // Crew member service validation
  selectServiceFirst: 'בחר שירות תחילה',
  notQualifiedForService: 'לא מוסמך לשירות זה',
  selectServiceToViewQualifiedMembers: 'בחר שירות כדי לראות את חברי הצוות המוסמכים',
  selectedMemberNotQualified: 'חבר הצוות הנבחר לא מוסמך לשירות החדש',
  selectedMemberCannotPerformService: 'חבר הצוות הנבחר אינו יכול לבצע את השירות הזה',

  // Form validation messages
  customerRequired: 'לקוח הוא שדה חובה',
  serviceRequired: 'שירות הוא שדה חובה',
  crewMemberRequired: 'חבר צוות הוא שדה חובה',
  dateRequired: 'תאריך הוא שדה חובה',
  timeRequired: 'שעה היא שדה חובה',
  validDurationRequired: 'נדרש משך זמן תקף',
  validPriceRequired: 'נדרש מחיר תקף',
  // Availability Warning translations
  availabilityConflict: 'התנגשות זמינות',
  availabilityConflictDescription: 'חבר הצוות לא זמין בזמן שנבחר',
  notAvailableAt: 'לא זמינ/ה ב',
  on: 'ב',
  isAvailableOn: 'זמינ/ה ב',
  during: 'במהלך',
  doesNotWorkOn: 'לא עובד/ת ב',
  canStillCreateAppointmentNote: '* ניתן עדיין ליצור את התור, אך שים לב להתנגשות הזמינות.',
  // Day names in Hebrew
  monday: 'יום שני',
  tuesday: 'יום שלישי',
  wednesday: 'יום רביעי',
  thursday: 'יום חמישי',
  friday: 'יום שישי',
  saturday: 'יום שבת',
  sunday: 'יום ראשון',
  // Additional time-related translations
  workingHours: 'שעות עבודה',
  availableHours: 'שעות זמינות',
  timeRange: 'טווח שעות',
  addTimeRange: 'הוסף טווח שעות',
  // Statistics and Counters
  todaysAppointments: 'תורים להיום',
  weeksAppointments: 'תורים השבוע',
  completedThisWeek: 'הושלמו השבוע',
  upcoming: 'קרובים',
  totalRevenue: 'הכנסות כוללות',
  weekRevenue: 'הכנסות השבוע',
  totalAppointments: 'סה"כ תורים',

  // Schedule View Elements
  timeSlot: 'משבצת זמן',
  emptySlot: 'משבצת פנויה',
  availableSlot: 'זמין להזמנה',
  clickToBook: 'לחץ להזמנה',

  // Appointment Status Display
  appointmentDetails: 'פרטי התור',
  duration: 'משך זמן',
  status: 'סטטוס',
  customer: 'לקוח',
  service: 'שירות',
  therapist: 'מטפלת',

  // Filter and Display Options
  showWeekend: 'הצג סוף שבוע',
  viewMode: 'מצב תצוגה',
  scheduleView: 'תצוגת יומן',

  // Loading and Error States
  loadingSchedule: 'טוען יומן...',
  scheduleError: 'שגיאה בטעינת היומן',
  noAppointments: 'אין תורים',
  noAppointmentsToday: 'אין תורים להיום',

  // Time Format Related
  morning: 'בוקר',
  afternoon: 'אחר הצהריים',
  evening: 'ערב',
  minutesShort: 'דק\'',
  hoursShort: 'ש\'',

  // Appointment Actions
  viewAppointment: 'צפה בתור',
  editAppointment: 'ערוך תור',
  cancelAppointment: 'בטל תור',
  rescheduleAppointment: 'תזמן מחדש',

  // Calendar Navigation
  currentWeek: 'השבוע הנוכחי',
  weekOf: 'שבוע של',
  goToToday: 'עבור להיום',
  navigateWeeks: 'נווט בין שבועות',

  // Crew Member Related
  assignedTo: 'משויך ל',
  unassigned: 'לא משויך',
  availableTherapists: 'מטפלות זמינות',
  specialties: 'התמחויות',

  // Statistics Labels
  appointmentCount: 'מספר תורים',
  completionRate: 'שיעור השלמה',
  revenueToday: 'הכנסות היום',
  weeklyStats: 'סטטיסטיקות שבועיות',

  // Schedule Grid
  scheduleGrid: 'רשת יומן',
  timeColumn: 'עמודת זמן',
  dayColumn: 'עמודת יום',
  appointmentCard: 'כרטיס תור',

  // Additional UI Elements
  refresh: 'רענן',
  print: 'הדפס',
  exportSchedule: 'ייצא יומן',
  scheduleSettings: 'הגדרות יומן',
  workingHours: 'שעות עבודה',

  // Days of Week (short forms for headers)
  sunShort: 'א\'',
  monShort: 'ב\'',
  tueShort: 'ג\'',
  wedShort: 'ד\'',
  thuShort: 'ה\'',
  friShort: 'ו\'',
  satShort: 'ש\'',

  // Responsive Design Labels
  mobileView: 'תצוגה ניידת',
  desktopView: 'תצוגה שולחנית',
  compactView: 'תצוגה קומפקטית',

  // Hebrew translations to add to src/constants/translations.js
  // Add these to the existing HEBREW_TRANSLATIONS object

  // Automations Section
  automations: 'אוטומציות',
  automationStudio: 'סטודיו לאוטומציות',
  manageAutomatedMessages: 'ניהול הודעות אוטומטיות ללקוחות שלך',
  setupAutomatedMessages: 'הגדר הודעות אוטומטיות ללקוחות שלך',
  newAutomation: 'אוטומציה חדשה',

  // AutomationsList translations
  searchAutomations: 'חפש אוטומציות...',
  showingAutomations: 'מציג {count} מתוך {total} אוטומציות',
  showingAutomation: 'מציג {count} מתוך {total} אוטומציה', // singular form
  clearFilters: 'נקה מסננים',
  noAutomationsYet: 'אין אוטומציות עדיין',
  createFirstAutomation: 'צור את האוטומציה הראשונה שלך כדי להתחיל לשלוח הודעות אוטומטיות ללקוחות שלך.',
  noAutomationsFound: 'לא נמצאו אוטומציות',
  adjustSearchCriteria: 'נסה להתאים את קריטריוני החיפוש או הסינון שלך.',

  // AutomationCard translations
  active: 'פעיל',
  inactive: 'לא פעיל',
  editAutomation: 'ערוך אוטומציה',
  deleteAutomation: 'מחק אוטומציה',
  messagePreview: 'תצוגה מקדימה של ההודעה:',
  hoursBefore: 'שעות לפני',
  hoursAfter: 'שעות אחרי',
  whenCreated: 'כאשר נוצר',
  automationActive: 'אוטומציה פעילה',
  automationInactive: 'אוטומציה לא פעילה',
  // AutomationModal translations
  editAutomationTitle: 'ערוך אוטומציה',
  createNewAutomationTitle: 'צור אוטומציה חדשה',
  automationName: 'שם אוטומציה',
  automationNameRequired: 'שם אוטומציה *',
  description: 'תיאור',
  whenShouldThisRun: 'מתי זה צריך לרוץ? *',
  automationNamePlaceholder: 'לדוגמה, תזכורת לתור',
  automationDescriptionPlaceholder: 'לדוגמה, מזכיר ללקוחות יומיים לפני',
  // AutomationToggle translations
  automationActive: 'פעיל',
  automationInactive: 'לא פעיל',
  // Automation confirmation messages
  deleteAutomationConfirm: 'האם אתה בטוח שברצונך למחוק אוטומציה זו?',
  automationDeleted: 'אוטומציה נמחקה בהצלחה',
  automationCreated: 'אוטומציה נוצרה בהצלחה',
  automationUpdated: 'אוטומציה עודכנה בהצלחה',
  automationToggled: 'סטטוס האוטומציה השתנה',
  // Automation error messages
  failedToCreateAutomation: 'שגיאה ביצירת האוטומציה',
  failedToUpdateAutomation: 'שגיאה בעדכון האוטומציה',
  failedToDeleteAutomation: 'שגיאה במחיקת האוטומציה',
  failedToToggleAutomation: 'שגיאה בשינוי סטטוס האוטומציה',
  // Automation trigger types (commonly used)
  appointmentReminder: 'תזכורת לתור',
  followUpMessage: 'הודעת מעקב',
  birthdayGreeting: 'ברכת יום הולדת',
  promotionalMessage: 'הודעה פרסומית',
  // Form validation messages for automations
  automationNameTooShort: 'שם האוטומציה חייב להכיל לפחות 3 תווים',
  automationNameTooLong: 'שם האוטומציה לא יכול להכיל יותר מ-100 תווים',
  triggerTypeRequired: 'סוג טריגר הוא שדה חובה',
  messageTemplateRequired: 'תבנית הודעה היא שדה חובה',
  trigger: 'טריגר',
  // Automation Modal - Missing Hebrew translations
  editAutomation: 'עריכת אוטומציה',
  createNewAutomation: 'יצירת אוטומציה חדשה',
  automationName: 'שם האוטומציה',
  description: 'תיאור',
  whenShouldThisRun: 'מתי זה צריך לרוץ?',
  hoursBeforeAppointment: 'שעות לפני התור',
  hoursAfterAppointment: 'שעות אחרי התור',
  messageTemplate: 'תבנית הודעה',
  messagePreview: 'תצוגה מקדימה של ההודעה',
  activateThisAutomationImmediately: 'הפעל אוטומציה זו מיד',
  updating: 'מעדכן...',
  creating: 'יוצר...',
  updateAutomation: 'עדכן אוטומציה',
  createAutomation: 'צור אוטומציה',
  failedToSaveAutomation: 'נכשל בשמירת האוטומציה',
  unexpectedErrorOccurred: 'אירעה שגיאה לא צפויה',
  between1And168Hours: 'בין 1 ל-168 שעות (שבוע אחד)',
  maximum1000Characters: 'מקסימום 1000 תווים',
  appointmentReminderExample: 'לדוגמה, תזכורת לתור',
  remindsClientsExample: 'לדוגמה, מזכיר ללקוחות יומיים לפני',
  // Trigger Type Options - Missing Hebrew translations
  beforeAppointmentReminder: 'לפני תור (תזכורת)',
  afterAppointmentFollowup: 'אחרי תור (מעקב)',
  whenAppointmentCreated: 'כאשר התור נוצר',
  whenAppointmentApproved: 'כאשר תור מאושר',
  // PlaceholderHelper - Missing Hebrew translations
  availablePlaceholders: 'משתנים זמינים',
  hide: 'הסתר',
  show: 'הצג',
  placeholders: 'משתנים',
  clickAnyPlaceholderBelow: 'לחץ על כל משתנה למטה כדי להכניס אותו לתבנית ההודעה',
  example: 'דוגמה:',
  customerName: 'שם הלקוח',
  customerNameDescription: 'השם המלא של הלקוח',
  serviceName: 'שם השירות',
  serviceNameDescription: 'שם השירות שהוזמן',
  appointmentDate: 'תאריך התור',
  appointmentDateDescription: 'תאריך התור',
  appointmentTime: 'שעת התור',
  appointmentTimeDescription: 'שעת התור',
  staffMemberName: 'שם חברת הצוות',
  staffMemberNameDescription: 'השם של חברת הצוות שהוקצתה',

  // Add these entries to the HEBREW_TRANSLATIONS object in src/constants/translations.js

  // CampaignsList.js strings
  searchCampaigns: 'חפש קמפיינים...',
  newCampaign: 'קמפיין חדש',
  createFirstCampaign: 'צור קמפיין ראשון',
  noCampaignsYet: 'אין קמפיינים עדיין',
  createFirstMarketingCampaign: 'צור את קמפיין השיווק הראשון שלך כדי להתחיל לעסוק עם לקוחות.',
  noCampaignsFound: 'לא נמצאו קמפיינים',
  adjustSearchTermsOrCreate: 'נסה לשנות את מונחי החיפוש או צור קמפיין חדש.',
  processing: 'מעבד...',

  // CampaignModal.js strings
  editCampaign: 'ערוך קמפיין',
  newCampaign: 'קמפיין חדש',
  campaignName: 'שם קמפיין',
  campaignNameRequired: 'שם קמפיין הוא שדה חובה',
  campaignNamePlaceholder: 'לדוגמה, מבצע זוהר קיץ',
  targetAudience: 'קהל יעד',
  targetAudienceRequired: 'קהל יעד הוא שדה חובה',
  targetAudiencePlaceholder: 'תאר את הלקוחות שברצונך לפנות אליהם (לדוגמה, לקוחות שלא הזמינו תורים ב-3 חודשים)',
  interpretAudience: 'נתח קהל יעד',
  interpreting: 'מפרש...',
  view: 'צפה ב',
  matchingAudience: 'לקוחות מתאימים',
  campaignType: 'סוג קמפיין',
  campaignTypeRequired: 'סוג קמפיין הוא שדה חובה',
  oneTime: 'חד פעמי',
  messageContent: 'תוכן הודעה',
  messageContentRequired: 'תוכן הודעה הוא שדה חובה',
  messageContentPlaceholder: 'כתוב את הודעת הקמפיין שלך כאן...',
  personalizeWithCustomerName: 'השתמש ב-{customer_name} כדי לפרסם הודעות עם פניה אישית ללקוח',
  saving: 'שומר...',
  updateCampaign: 'עדכן קמפיין',
  createCampaign: 'צור קמפיין',
  days: 'ימים',
  weeks: 'שבועות',
  months: 'חודשים',
  aiAnalyzingTargetAudience: 'AI מנתח את קהל היעד לפי הטקסט שרשמת...',
  failedToInterpretAudience: 'נכשל בפרשנות קהל יעד',
  failedToLoadCustomers: 'נכשל בטעינת לקוחות',

  // Additional Campaign Management strings
  campaignCreatedSuccessfully: 'קמפיין נוצר בהצלחה',
  campaignUpdatedSuccessfully: 'קמפיין עודכן בהצלחה',
  campaignDeletedSuccessfully: 'קמפיין נמחק בהצלחה',
  failedToCreateCampaign: 'נכשל ביצירת קמפיין',
  failedToUpdateCampaign: 'נכשל בעדכון קמפיין',
  failedToDeleteCampaign: 'נכשל במחיקת קמפיין',
  confirmDeleteCampaign: 'האם אתה בטוח שברצונך למחוק קמפיין זה?',
  deleteCampaignWarning: 'פעולה זו לא ניתנת לביטול.',
  campaignStatus: 'סטטוס קמפיין',
  campaignWithThisNameExists: 'קמפיין עם שם זה כבר קיים',
  campaignNotFound: 'קמפיין לא נמצא',

  // Campaign execution and audience
  noCustomersFound: 'לא נמצאו לקוחות',
  oneCustomerFound: '1 לקוח נמצא',
  customersFound: 'לקוחות נמצאו',
  viewCustomers: 'צפה בלקוחות',
  hideCustomers: 'הסתר לקוחות',
  aiInterpretation: 'פרשנות AI',
  sqlQuery: 'שאילתת SQL',
  loadingCustomers: 'טוען לקוחות...',
  executionTimestamp: 'חותמת זמן ביצוע',
  customerData: 'נתוני לקוח',

  // Customer display fields
  fullName: 'שם מלא',
  skinType: 'סוג עור',
  preferredContact: 'פנייה מועדפת',
  totalSpent: 'סה"כ הוצאות',
  totalAppointments: 'סה"כ תורים',
  lastAppointmentDate: 'תאריך תור אחרון',
  daysSinceLastAppointment: 'ימים מאז תור אחרון',
  never: 'אף פעם',

  // Campaign type translations (for values)
  oneTime: 'חד פעמי',
  days: 'ימים',
  weeks: 'שבועות',
  months: 'חודשים',

  // CampaignCard specific strings
  target: 'יעד:',
  sends: 'עיתוי שליחה:',
  noDateSet: 'לא נקבע תאריך',
  today: 'היום',
  overdue: 'איחור',
  active: 'פעיל',
  inactive: 'לא פעיל',
  created: 'נוצר:',
  updated: 'עודכן:',
  confirmDeleteCampaign: 'האם אתה בטוח שברצונך למחוק',

  //Working Hours 
  startTime: 'שעת התחלה',
  endTime: 'שעת סיום',
  selectStartTime: 'בחר זמן התחלה',
  from: 'מ',
  to: 'עד',
  workingHours: 'שעות עבודה',

  // Customer Statistics Status Translations
  customerStatsTranslations: {
    // Activity Status
    activityStatus: {
      'Active': 'פעיל',
      'Inactive': 'לא פעיל',
      'Dormant': 'רדום'
    },

    // Value Description
    valueDescription: {
      'High Value': 'לקוח יקר',
      'Good Value': 'לקוח טוב',
      'Regular': 'לקוח רגיל',
      'New': 'לקוח חדש'
    },

    // Frequency Description  
    frequencyDescription: {
      'Frequent Visitor': 'מבקר תכוף',
      'Regular Visitor': 'מבקר קבוע',
      'Occasional Visitor': 'מבקר מזדמן',
      'New Customer': 'לקוח חדש'
    },

    // Tenure Description
    tenureDescription: {
      'Long-term Customer': 'לקוח ותיק',
      'Established Customer': 'לקוח מבוסס',
      'Regular Customer': 'לקוח קבוע',
      'New Customer': 'לקוח חדש'
    }
  },

  // Additional stat-related translations
  statsLabels: {
    completed: 'הושלמו',
    aboveAverage: 'מעל הממוצע',
    daysSinceLastVisit: 'ימים מאז הביקור האחרון',
    never: 'מעולם לא',
    today: 'היום',
    yesterday: 'אתמול',
    daysAgo: 'ימים',
    activityStatus: 'סטטוס פעילות',
    valueRating: 'דירוג ערך',
    visitFrequency: 'תדירות ביקור',
    customerTenure: 'וותק לקוח'
  },

// Add these translations to src/constants/translations.js

// Payment-related translations
payment: 'תשלום',
paymentStatus: 'סטטוס תשלום',
paymentAmount: 'סכום תשלום',
paymentMethod: 'אמצעי תשלום',
paymentDate: 'תאריך תשלום',
paymentTransactionId: 'מספר עסקה',

// Payment actions
requestPayment: 'בקש תשלום',
requestPaymentLink: 'צור קישור תשלום',
cancelPaymentRequest: 'בטל בקשת תשלום',
viewPaymentDetails: 'צפה בפרטי תשלום',
sendPaymentLink: 'שלח קישור תשלום',

// Payment status labels (Hebrew)
paymentNotRequested: 'טרם נדרש תשלום',
paymentPending: 'ממתין לתשלום',
paymentCompleted: 'שולם',
paymentFailed: 'תשלום נכשל',
paymentExpired: 'קישור תשלום פג',
paymentCancelled: 'תשלום בוטל',

// Payment methods
creditCard: 'כרטיס אשראי',
bit: 'ביט',
applePay: 'Apple Pay',
googlePay: 'Google Pay',
bankTransfer: 'העברה בנקאית',

// Payment messages
paymentLinkCreated: 'קישור תשלום נוצר בהצלחה',
paymentLinkSent: 'קישור תשלום נשלח ללקוח',
paymentReceived: 'תשלום התקבל בהצלחה',
paymentLinkExpired: 'קישור התשלום פג תוקף',
paymentLinkExpiresIn: 'קישור התשלום יפוג בעוד',
paymentProcessing: 'מעבד תשלום...',

// Payment errors
paymentCreationFailed: 'יצירת קישור תשלום נכשלה',
paymentValidationFailed: 'אימות תשלום נכשל',
paymentAlreadyRequested: 'תשלום כבר נדרש עבור תור זה',
paymentCannotBeCancelled: 'לא ניתן לבטל את בקשת התשלום',

// Payment confirmation
confirmCancelPayment: 'האם אתה בטוח שברצונך לבטל את בקשת התשלום?',
confirmRequestPayment: 'האם אתה בטוח שברצונך לבקש תשלום מהלקוח?',

// Payment info
paymentLinkValidFor: 'קישור תקף למשך 10 דקות',
paymentSecureConnection: 'חיבור מאובטח',
paymentMultipleMethods: 'מספר אמצעי תשלום זמינים',

// Add after existing payment translations (around line with paymentMultipleMethods)

// Invoice translations
invoice: 'חשבונית',
invoiceNumber: 'מספר חשבונית',
downloadInvoice: 'הורד חשבונית',
viewInvoice: 'צפה בחשבונית',
invoiceAvailable: 'חשבונית זמינה',
invoiceReady: 'חשבונית מוכנה להורדה',
openInvoiceInNewTab: 'פתח חשבונית בכרטיסייה חדשה',
invoiceGenerated: 'חשבונית הופקה',

  // Phone Verification Section
  phoneVerification: 'אימות טלפון (בדיקה)',
  customerPhoneVerification: 'אימות טלפון לקוח',
  verifyCustomerPhoneNumbers: 'אמת מספרי טלפון של לקוחות לפני קביעת תורים',
  phoneNumber: 'מספר טלפון',
  sendVerificationCode: 'שלח קוד אימות',
  verificationCode: 'קוד אימות',
  verifyCode: 'אמת קוד',
  startOver: 'התחל מחדש',
  verifyAnotherNumber: 'אמת מספר נוסף',
  sending: 'שולח...',
  verifying: 'מאמת...',
  includeCountryCode: 'כלול קוד מדינה (לדוגמה: +972 לישראל)',
  enterSixDigitCode: 'הכנס קוד בן 6 סיפרות',
  verificationCodeSent: 'קוד אימות נשלח בהצלחה!',
  phoneNumberVerifiedSuccessfully: '✅ מספר הטלפון אומת בהצלחה! הלקוח יכול כעת לקבוע תורים.',
  phoneNumberNotFound: 'מספר הטלפון לא נמצא במערכת הלקוחות שלנו',
  failedToSendVerification: 'נכשל בשליחת האימות',
  verificationFailed: 'האימות נכשל',
  invalidCode: 'קוד לא תקין',
  networkError: 'שגיאת רשת',
  mockCustomerDatabase: 'מסד נתונים דמה של לקוחות:',
  tryOneOfTheseNumbers: 'נסה אחד מהמספרים הללו לבדיקת תהליך האימות.',
  verifyDifferentNumber: 'אמת מספר אחר',
  clearVerification: 'נקה אימות',
  verifiedPhone: 'טלפון מאומת',

  insights: 'תובנות',
  viewInsightsAndAnalytics: 'צפה בתובנות וניתוחים של העסק שלך',

  // Customer Notes
  customerNotes: 'הערות לקוח',
  addNote: 'הוסף הערה',
  enterNoteText: 'הזן טקסט הערה...',
  noNotesYet: 'אין הערות עדיין. הוסף את ההערה הראשונה שלך למעלה.',
  loadingNotes: 'טוען הערות...',
  confirmDeleteNote: 'האם אתה בטוח שברצונך למחוק הערה זו?',
  edited: 'נערך',

  "charts": {
    "periods": {
      "3m": "3 חודשים",
      "6m": "6 חודשים",
      "1y": "שנה",
      "2y": "שנתיים",
      "5y": "5 שנים",
      "10y": "10 שנים",
      "all": "כל הזמנים",
      "max": "מקסימום"
    },
    "appointments": "תורים",
    "appointmentsTrend": {
      "title": "מגמת תורים חודשית",
      "description": "עקוב אחר צמיחת העסק והתבניות של התורים לאורך זמן",
      "peakMonth": "חודש שיא",
      "average": "ממוצע",
      "total": "סה״כ",
      "trend": "מגמה"
    },
    "valueOverTime": {
      "title": "מגמת תורים חודשית",
      "description": "כמות תורים שנקבעו בכל חודש - ניתן לראות מגמות של צמיחת העסק",
      "peakMonth": "חודש שיא",
      "average": "ממוצע",
      "total": "סה״כ",
      "trend": "מגמה"
    },
    "yearOverYear": {
      "title": "השוואה חודשית שנה לעומת שנה",
      "description": "השוואה של כמות תורים שנקבעו בחודש לעומת אותו החודש בשנים קודמות",
      "avgYoyGrowth": "צמיחה ממוצעת שנתית",
      "bestMonth": "החודש הטוב ביותר",
      "yearsCompared": "שנים בהשוואה",
      "bestYearTotal": "סה״כ השנה הטובה ביותר"
    },
    "dashboard": {
      "title": "ניתוח השוואת תורים",
      "description": "השווה מגמות תורים בין שנים שונות כדי לזהות תבניות וצמיחה",
      "refreshData": "רענן נתונים",
      "loading": "טוען...",
      "loadingAppointmentData": "טוען נתוני תורים...",
      "errorLoadingData": "שגיאה בטעינת הנתונים",
      "retry": "נסה שוב",
      "dataOverview": "סקירת נתונים",
      "dataPeriod": "תקופת נתונים:",
      "totalMonths": "סה״כ חודשים:",
      "totalAppointments": "סה״כ תורים:",
      "analysisInsights": "תובנות ניתוח",
      "howToUse": "איך להשתמש בגרף הזה:",
      "keyMetrics": "מדדים עיקריים:",
    },
    "months": {
      "jan": "ינו׳",
      "feb": "פבר׳",
      "mar": "מרץ",
      "apr": "אפר׳",
      "may": "מאי",
      "jun": "יוני",
      "jul": "יולי",
      "aug": "אוג׳",
      "sep": "ספט׳",
      "oct": "אוק׳",
      "nov": "נוב׳",
      "dec": "דצמ׳"
    }
  }
};

